(function () {
  'use strict';

  function lock(on) { document.body.classList.toggle('dl-locked', on); }

  if (!customElements.get('dl-drawer')) {
    customElements.define('dl-drawer', class extends HTMLElement {
      connectedCallback() {
        this.querySelectorAll('[data-dl-drawer-close]').forEach((el) => el.addEventListener('click', () => this.close()));
        document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && this.classList.contains('is-open')) this.close(); });
      }
      open() { this.classList.add('is-open'); lock(true); document.querySelectorAll('[data-dl-drawer-open]').forEach((b) => b.setAttribute('aria-expanded', 'true')); }
      close() { this.classList.remove('is-open'); lock(false); document.querySelectorAll('[data-dl-drawer-open]').forEach((b) => b.setAttribute('aria-expanded', 'false')); }
    });
  }

  if (!customElements.get('dl-header')) {
    customElements.define('dl-header', class extends HTMLElement {
      connectedCallback() {
        this.querySelectorAll('[data-dl-drawer-open]').forEach((b) => b.addEventListener('click', () => {
          const d = document.querySelector('[data-dl-drawer]');
          if (d) d.open();
        }));
        this.nav = this.querySelector('.dl-nav');
        this.onScroll = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.onScroll();
        this.querySelectorAll('.dl-nav__item details').forEach((d) => {
          const li = d.closest('.dl-nav__item');
          let t;
          li.addEventListener('mouseenter', () => { clearTimeout(t); this.closeMenus(d); d.open = true; });
          li.addEventListener('mouseleave', () => { t = setTimeout(() => { d.open = false; }, 150); });
          d.addEventListener('toggle', () => { if (d.open) this.closeMenus(d); });
        });
        document.addEventListener('click', (e) => { if (!this.contains(e.target)) this.closeMenus(); });
      }
      closeMenus(except) { this.querySelectorAll('.dl-nav__item details[open]').forEach((d) => { if (d !== except) d.open = false; }); }
      onScroll() {
        if (this.ticking) return;
        this.ticking = true;
        requestAnimationFrame(() => {
          this.ticking = false;
          const section = this.closest('.shopify-section') || this;
          let before = 0;
          for (let el = section.previousElementSibling; el; el = el.previousElementSibling) before += el.offsetHeight;
          const compact = this.classList.contains('is-compact');
          const full = compact ? this.fullHeight : section.offsetHeight;
          const want = window.scrollY > before + full;
          if (want === compact) return;
          if (want) {
            this.fullHeight = section.offsetHeight;
            this.classList.add('is-compact');
            section.style.marginBottom = Math.max(0, this.fullHeight - section.offsetHeight) + 'px';
          } else {
            this.classList.remove('is-compact');
            section.style.marginBottom = '';
          }
        });
      }
    });
  }

  document.addEventListener('click', (e) => {
    const tab = e.target.closest('[data-dl-tab]');
    if (!tab) return;
    const shell = tab.closest('[data-dl-tabs]');
    shell.querySelectorAll('[data-dl-tab]').forEach((b) => { const on = b === tab; b.classList.toggle('is-active', on); b.setAttribute('aria-selected', on ? 'true' : 'false'); });
    shell.querySelectorAll('[data-dl-panel]').forEach((p) => { p.hidden = p.getAttribute('data-dl-panel') !== tab.getAttribute('data-dl-tab'); });
  });

  function addBusinessDays(date, days) {
    const d = new Date(date);
    let n = 0;
    while (n < days) { d.setDate(d.getDate() + 1); const w = d.getDay(); if (w !== 0 && w !== 6) n++; }
    return d;
  }
  function fillShipDates() {
    document.querySelectorAll('[data-dl-ship-date]').forEach((el) => {
      const days = parseInt(el.getAttribute('data-dl-ship-date'), 10) || 2;
      const d = addBusinessDays(new Date(), days);
      el.textContent = d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
    });
  }
  if (document.readyState !== 'loading') fillShipDates(); else document.addEventListener('DOMContentLoaded', fillShipDates);

  document.addEventListener('change', (e) => {
    const q = e.target.closest('[data-dl-qty]');
    if (q) q.closest('.dl-qty').classList.toggle('has-value', !!q.value);
  });
  const RECENT_KEY = 'dl-recent';
  function readRecent() { try { return JSON.parse(localStorage.getItem(RECENT_KEY)) || []; } catch (e) { return []; } }
  function writeRecent(v) { try { localStorage.setItem(RECENT_KEY, JSON.stringify(v)); } catch (e) {} }
  const recentItem = document.getElementById('DlRecentItem');
  if (recentItem) {
    try {
      const it = JSON.parse(recentItem.textContent);
      writeRecent([it].concat(readRecent().filter((x) => x.handle !== it.handle)).slice(0, 10));
    } catch (e) {}
  }
  if (!customElements.get('dl-recent')) {
    customElements.define('dl-recent', class extends HTMLElement {
      connectedCallback() {
        const clear = this.querySelector('[data-dl-recent-clear]');
        if (clear) clear.addEventListener('click', () => { writeRecent([]); this.render(); });
        this.render();
      }
      render() {
        const list = this.querySelector('[data-dl-recent-list]');
        const items = readRecent().filter((x) => x && x.url && x.handle !== this.dataset.current).slice(0, 6);
        list.textContent = '';
        items.forEach((x) => {
          const li = document.createElement('li');
          const a = document.createElement('a'); a.href = x.url;
          if (x.img) { const img = document.createElement('img'); img.src = x.img; img.alt = x.title || ''; img.loading = 'lazy'; img.width = 160; img.height = 160; a.appendChild(img); }
          const t = document.createElement('span'); t.textContent = x.title || ''; a.appendChild(t);
          if (x.price) { const pr = document.createElement('span'); pr.className = 'dl-recent__price'; pr.textContent = x.price; a.appendChild(pr); }
          li.appendChild(a); list.appendChild(li);
        });
        this.hidden = items.length === 0;
      }
    });
  }

  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-dl-desc-toggle]');
    if (t) {
      e.preventDefault();
      const body = t.parentElement.querySelector('[data-dl-desc]');
      if (!body) return;
      body.hidden = !body.hidden;
      t.textContent = body.hidden ? t.dataset.show : t.dataset.hide;
      return;
    }
    const acc = e.target.closest('[data-dl-acc-toggle]');
    if (acc) {
      const item = acc.closest('.dl-menulist__item');
      const closed = item.classList.toggle('is-closed');
      acc.setAttribute('aria-expanded', closed ? 'false' : 'true');
    }
  });
  let filterTimer;
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-dl-filters] [data-dl-filter-input]');
    if (input) {
      const form = input.form;
      clearTimeout(filterTimer);
      filterTimer = setTimeout(() => {
        form.querySelectorAll('input[type="number"]').forEach((i) => { if (i.value === '') i.disabled = true; });
        form.submit();
      }, input.type === 'number' ? 600 : 0);
      return;
    }
    const sort = e.target.closest('[data-dl-sort]');
    if (sort) {
      const u = new URL(window.location.href);
      u.searchParams.set('sort_by', sort.value);
      u.searchParams.delete('page');
      window.location.href = u.toString();
    }
  });

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-dl-filter-open]');
    if (!btn) return;
    const panel = document.querySelector('[data-dl-filter-panel]');
    if (!panel) return;
    panel.hidden = !panel.hidden;
    btn.setAttribute('aria-expanded', panel.hidden ? 'false' : 'true');
  });
})();
